<!-- Main section - right -->
<div class="device_card_wrapper right_section" id="deviceSegments">
  <div class="right_section_header" id="deviceRightSec">
    <span class="header_icon segment_icons"></span>
    <span i18n="@@device-segment.main-section-headers.segment">SEGMENT</span>
  </div>

  <div class="mt-3" [ngClass]="isSegmentEmpty ? 'existing_text_show': 'existing_text_hide'" id="assetLibraryDiv">
    <span i18n="@@device-segment.no.segment-info">There is no Segment in the <strong>Asset Library</strong></span>
  </div>
  <iposcen-spinner-overlay></iposcen-spinner-overlay>
  <div class="right_section_body" *ngIf="displaySegmentGroups?.length >= 0" id="displaySegGrp">
    <span i18n="@@device-segment.heading.total-segment-group"><strong>{{displaySegmentGroups?.length}} Segment
        Groups</strong></span>
    <div class="mt-4 mb-4" id="segmentColor">
      <span i18n="@@device-segment.heading.segment-info">Select a device segment for this device to help with the sales
        process. Every segment is associated with a color.</span>
    </div>

    <!-- Content groups - Accordion -->
    <div class="accordion" id="devicesSegmentAcc">
      <div class="card d-flex flex-row" id="card">
        <div class="acc_check" id="accCheck">
          <div>
            <input type="radio" name="cpLCGSelect" [value]="isdeviceSegmentNone" [checked]="isdeviceSegmentNone"
              (change)="removeShowonDeveice()" />
          </div>
        </div>
        <div class="card-header-content" id="cardHeaderCon">
          <div class="title_left none_title_left" id="noneTtlLeft">
            <div class="d-flex" id="nonFlex">
              <div class="title none_title" id="noneTitle">
                <span i18n="@@device-price-content.title.none-label">None</span>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="card"
        *ngFor="let segmentGroup of displaySegmentGroups | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; index as i" id="card">
        <div class="card-header small_text" id="segmentOne">
          <div class="acc_check" id="accCheck">
            <div class="form-check" id="segOneFrmCheck">
              <input type="radio" name="cpLCGSelect" class="form-check-input" [value]="segmentGroup?.showOnDevice"
                [checked]="isSelectedData.has(segmentGroup.id)" (change)="addShowonDeveice($event,i,segmentGroup)" />
            </div>
          </div>

          <div class="card-header-content" id="cardHeader">
            <div class="title_left" id="titleLeft">
              <div class="d-flex" id="cardFlex">
                <div class="segment_color_badge" [style.background]="segmentGroup?.configurations?.segmentBgColor" id="segmentColorBagde">
                </div>
                <div class="title" id="title">
                  <span>{{segmentGroup?.configurations?.publishedName}} &nbsp;&nbsp;</span>
                </div>
              </div>
              <div *ngIf="(segmentGroup.isContentExpires)" id="contentExpire" class="content-expire"><img class="contents-info-icon" alt="info_icon"><span>{{globConst.CONT_GRP_EXPIRED_TEXT}}</span></div>
            </div>
          </div>
          <div class="collapse_link collapsed {{segmentGroup?.id}}" type="button"
            (click)="getDetailsOfSegment(segmentGroup?.id)" [ngClass]="segmentGroup.isExpanded ? 'transform-180' : ''" id="segIsExpanded">
            <svg class="accordian_expanded" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M2.469 6.96936C2.53867 6.89952 2.62143 6.8441 2.71255 6.80629C2.80367 6.76849 2.90135 6.74902 3 6.74902C3.09865 6.74902 3.19633 6.76849 3.28745 6.80629C3.37857 6.8441 3.46133 6.89952 3.531 6.96936L12 15.4399L20.469 6.96936C20.5387 6.89963 20.6215 6.84432 20.7126 6.80658C20.8037 6.76884 20.9014 6.74942 21 6.74942C21.0986 6.74942 21.1963 6.76884 21.2874 6.80658C21.3785 6.84432 21.4613 6.89963 21.531 6.96936C21.6007 7.0391 21.656 7.12188 21.6938 7.21299C21.7315 7.3041 21.7509 7.40175 21.7509 7.50036C21.7509 7.59898 21.7315 7.69663 21.6938 7.78774C21.656 7.87885 21.6007 7.96163 21.531 8.03136L12.531 17.0314C12.4613 17.1012 12.3786 17.1566 12.2874 17.1944C12.1963 17.2322 12.0986 17.2517 12 17.2517C11.9013 17.2517 11.8037 17.2322 11.7125 17.1944C11.6214 17.1566 11.5387 17.1012 11.469 17.0314L2.469 8.03136C2.39915 7.9617 2.34374 7.87893 2.30593 7.78781C2.26812 7.6967 2.24866 7.59901 2.24866 7.50036C2.24866 7.40171 2.26812 7.30403 2.30593 7.21291C2.34374 7.1218 2.39915 7.03903 2.469 6.96936Z" />
            </svg>
          </div>
        </div>
        <div id="collapseSegmentOne" class="collapse" [ngbCollapse]="isCollapsed" #collapse="ngbCollapse"
          [(ngbCollapse)]="!segmentGroup.isExpanded">
          <div class="card-body" id="cardBody">
            <div class="validity_info" id="validityInfo">
              <table id="deviceSegment_table" class="table-borderless" aria-describedby="segmnent_tables">
                <tr>
                  <th scope="col">
                    <span i18n="@@segments.expanded-segment.publish-date">Publishing Date and Time</span>
                  </th>
                  <th scope="col">
                    <span i18n="@@segments.expanded-segment.expire-date">Expiration Date and Time</span>
                  </th>
                </tr>
                <tr>
                  <td>
                    {{segmentGroup?.configurations?.publishTime | dateFormat: "24hrP"}}
                  </td>
                  <td>
                    {{segmentGroup?.configurations?.expireTime | dateFormat: "24hrP"}}
                  </td>
                </tr>
              </table>
            </div>

            <div id="IdleExperiencePreviewSection" class="form-group idleExperiencePreviewSection" *ngIf="segmentGroup?.configurations?.contentGroupPages?.length">
              <form>
                <div [ngClass]="{'width-Added-other-language': ['cs','pl'].includes(globConst.IPOS_LANGUAGE)}">
                  <input type="radio" name="ptPCGSelect" class="form-check-input" value=globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS
                      (change)="togglePreviewTabs(globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS, segmentGroup?.id)" [checked]= "globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS ==  segmentGroup.isIdleExperienceEnabled"/>
                      <label class="form-check-input" for="isIdleExperiencePreview">
                          {{globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS}}
                      </label>
                  </div>
                  <div>
                      <input type="radio" name="ptPCGSelect" class="form-check-input" value=globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE
                      [checked]= "globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE ==  segmentGroup.isIdleExperienceEnabled"
                      (change)="togglePreviewTabs(globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE, segmentGroup?.id)" />
                      <label class="form-check-input" for="isIdleExperiencePreview">
                          {{globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE}}
                      </label>
                  </div>
              </form>
            </div>
            <div class="acc_expand_img_container" id="accExpandImgCon">

              <div class="mini-preview-container" id="minPreviewCon">
                <ng-container *ngFor="let page of segmentGroup?.configurations?.contentGroupPages">
                  <iposcen-mini-live-preview [data]="loadMiniPreview(segmentGroup.id,page)"
                  [isIdleExperienceEnable]="segmentGroup.isIdleExperienceEnabled"></iposcen-mini-live-preview>                                  
                </ng-container>
              </div>

              <div class="applicability_title" id="applicablitiyTitle">
                <span i18n="@@segments.mini-preview.content-group">Content Group Applies To</span>:
              </div>
              <div class="applicability_roles" id="applicablility">
                <div id="deviceTypesMain">
                  <div id="deviceTypesDiv"><span class="font-bold">{{deviceTypes}}</span>:
                    {{ segmentGroup?.configurations?.formFactor?.devices}}
                  </div>
                </div>
                <div id="manufacturerMainDiv">
                  <div id="manufacturerChildDiv">
                    <span class="font-bold">{{manufacturers}}</span>:
                    {{ segmentGroup?.configurations?.formFactor?.manufacturer}}
                  </div>
                </div>
                <div id="processorMainDiv">
                  <div id="processorChildDiv"><span class="font-bold">{{processors}}</span>:
                    {{ segmentGroup?.configurations?.formFactor?.processors}}
                  </div>
                </div>
                <div id="generationMainDiv">
                  <div id="generationChildDiv"><span class="font-bold">{{generation}}</span>:
                    {{ segmentGroup?.configurations?.formFactor?.generations}}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination -->

    <div class="d-flex flex-column align-items-center mt-auto" id="displaySegGrp">
      <nav aria-label="logo content pagination" *ngIf="displaySegmentGroups && displaySegmentGroups?.length>0">
        <ngb-pagination [collectionSize]="displaySegmentGroups?.length" [(page)]="page" [pageSize]="pageSize"
          [rotate]="true" [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false">
        </ngb-pagination>
      </nav>
    </div>

  </div>
  <!-- CTA Buttons -->
  <div class="button_wrapper justify-content-end" *ngIf="displaySegmentGroups?.length>=0" id="btnWrapper">
    <button type="button" class="btn btn-outline-primary btn-lg" data-dismiss="modal" [disabled]="!isRadioBtnSelected" (click)='cancel()'>
      {{cancelBtn}}
    </button>
    <button type="button" class="btn btn-primary btn-lg gtmEditDeviceSavePromoContent" [disabled]="!isRadioBtnSelected" (click)="saveSegmentChange()">
      <span i18n="@@device-segment.button.save-changes">Save Changes</span>
    </button>
  </div>
</div>


<!-- remove-popup-message -->
<div class="container" id="container">
  <div class="modal-dialog-centered" *ngIf="openModalPopup" id="modalDialogPopup">
    <div class="modal-backdrop show" id="modalBackdrop"></div>
    <div class="modal" id="myModal">
      <div class="modal-dialog" id="myModalDialog">
        <div class="modal-content" id="modalContent">
          <div _ngcontent-fjy-c198="" class="close" (click)="closeModal()"><img _ngcontent-fjy-c198="" alt="close"
              class="modal-close-icon" id="modalClose"></div>
          <div class="modal-body" id="modalBody">
            <div class="action-success-msg left_align_title left_align" id="actionSuccessMsg">
              <span>{{successMessage}}</span>
            </div>
            <div class="card_desc left_align" id="cardDesc">
              <span>{{description}}</span>
            </div>
          </div>
          <div *ngIf='isCancel' class='modal-footer' id="modalFooter">
            <button class='btn btn-outline-primary btn-lg' (click)="closeModal()">{{buttonLabelNo}}</button>
            <button class='btn btn-primary btn-lg' (click)='dismiss()'>{{buttonLabelCancel}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="container" id="containerDiv">
  <div class="modal-dialog-centered" *ngIf="openSuccessPopup" id="modalDialog">
    <div class="modal-backdrop show" id="modalBackDrop"></div>
    <div class="modal" id="myModal">
      <div class="modal-dialog" id="myModalDialog">
        <div class="modal-content" id="myModalContent">
          <div _ngcontent-fjy-c198="" class="close" (click)="closeSuccessModal()"><img _ngcontent-fjy-c198=""
              alt="close" class="modal-close-icon" id="myModalClose"></div>
          <div class="modal-body" id="modalBody">
            <div class="action_on_pending_user" id="actionOnPending">
              <span class="success_img"></span>
            </div>
            <div class="action-success-msg" id="actionSuccessMsg">
              <span>{{successMessage}}</span>
            </div>
            <div class="card_desc left_align" id="cardDesc">
              <span>{{description}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>